// extracted by mini-css-extract-plugin
export default {"wrapper":"_b147fa6f"};